import { ActionTree } from "vuex";
// import request from "@/utils/Request";
// import Toast from "@/utils/Toast";
import { state } from "./types";
// const localUrl = "informatics_officials/";

const actions: ActionTree<state, unknown> = {};

export default actions;
